export const supportedButtonsProps = [
  {
    logo: {
      path: '/icons/brands/Facebook.svg',
      width: 18,
      height: 18,
    },
    caption: 'Facebook',
    provider: 'facebook',
  },
  {
    logo: {
      path: '/icons/brands/Google.svg',
      width: 18,
      height: 18,
    },
    caption: 'Google',
    provider: 'google',
  },
  {
    logo: {
      path: '/icons/brands/Apple.svg',
      width: 18,
      height: 18,
    },
    caption: 'Apple ID',
    provider: 'apple',
  },
];
